import { Link } from 'react-router-dom';
import logoDecode from '../../assets/LogoDecode.jpeg';
import './Footer.css';

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ftr">
      <div className="ftr__inner">

        {/* ── Marca ── */}
        <div className="ftr__brand">
          <Link to="/" className="ftr__logo">
            <img src={logoDecode} alt="Decode Byte" />
            <span>Decode<strong>Byte</strong></span>
          </Link>
          <p className="ftr__tagline">
            Transformando código em oportunidade real. Startup de tecnologia nascida em Recife-PE,
            construindo soluções que conectam pessoas e impactam vidas.
          </p>
          <div className="ftr__social">
            <a
              href="https://www.instagram.com/decodebyte"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://linkedin.com/company/decodebyte"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://facebook.com/decodebyte"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
          </div>
        </div>

        {/* ── Produto ── */}
        <div className="ftr__col">
          <h4>Produto</h4>
          <ul>
            <li><Link to="/tarefas-perto">Tarefas Perto</Link></li>
            <li><a href="/#tecnologia">Tecnologia</a></li>
            <li><a href="/#roadmap">Roadmap</a></li>
            <li><a href="/#produtos">Outros Produtos</a></li>
          </ul>
        </div>

        {/* ── Empresa ── */}
        <div className="ftr__col">
          <h4>Empresa</h4>
          <ul>
            <li><Link to="/sobre">Sobre Nós</Link></li>
            <li><a href="/#credibilidade">Apoio Institucional</a></li>
            <li><Link to="/contato">Trabalhe Conosco</Link></li>
            <li><Link to="/contato">Seja Parceiro</Link></li>
          </ul>
        </div>

        {/* ── Legal ── */}
        <div className="ftr__col">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/termos">Termos de Uso</Link></li>
            <li><Link to="/privacidade">Política de Privacidade</Link></li>
          </ul>
        </div>

        {/* ── Contato ── */}
        <div className="ftr__col">
          <h4>Contato</h4>
          <ul className="ftr__contact-list">
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <span>Recife — Pernambuco, Brasil</span>
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              <a href="mailto:decodebytestartup@gmail.com">
                decodebytestartup@gmail.com
              </a>
            </li>
            <li>
              <i className="fas fa-clock"></i>
              <span>Seg–Sex · 9h às 17h</span>
            </li>
          </ul>
        </div>

      </div>

      <div className="ftr__bottom">
        <div className="ftr__bottom-inner">
          <p>&copy; {year} Decode Byte · Todos os direitos reservados</p>
          <p className="ftr__bottom-right">
            Feito com <i className="fas fa-heart"></i> no Nordeste do Brasil
          </p>
        </div>
      </div>
    </footer>
  );
};
